import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { VIEWS_CHANGE } from "../../Actions/Kiosk/viewsConfigurationChangeAction";
import { VIEWS_RESET } from '../../Actions/Kiosk/viewsConfigurationResetAction';
import storeState, { emptyState } from "../../../utils/storeState";
import { storageKeyViews } from "../../../model/StorageKeys";
import { defaultViewsConfiguration } from "../../../model/DefaultConfiguration";

export default function viewsConfigurationReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch(action.type) {
    case VIEWS_CHANGE:
      storeState(storageKeyViews, action.payload.viewsConfiguration);
      return {
        ...state,
        viewsConfiguration: action.payload.viewsConfiguration
      }
    case VIEWS_RESET:
      emptyState(storageKeyViews);
      return {
        ...state,
        viewsConfiguration: defaultViewsConfiguration
      }
    }

  return state;
}
